import { gql, graphQueryBang } from "shared/lib/graphql"

const topServicesforCategoryQuery = gql`
  query(
    $service: String!
    $category_name: String
    $current_metric_date: DataServiceDate!
  ) {
    categories: service_metrics(
      channel_module_name: $service
      category_name: $category_name
      metric_start_date: $current_metric_date
      metric_end_date: $current_metric_date
    ) {
      category_metrics {
        metrics {
          top_services_last_30_days {
            channel {
              monochrome_image_url
            }
          }
        }
      }
    }
  }
`

export default function fetchWorksWithIcons(
  serviceModuleName,
  categoryName,
  currentMetricDate
) {
  return graphQueryBang(topServicesforCategoryQuery, {
    service: serviceModuleName,
    category_name: categoryName,
    current_metric_date: currentMetricDate,
  })
    .then(data =>
      data.categories.category_metrics[0].metrics[0].top_services_last_30_days.map(
        s => s.channel.monochrome_image_url
      )
    )
    .catch(() => [])
}
